import React, { useState, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Row } from "react-bootstrap"
import { Typography, useTheme } from "@mui/material"

import ListView from "./ListView"
import Card from "components/Card/Card"
import AddMenuItemButton from "components/StyledComponents/addNewItemButton"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"

import editIcon from "assets/icons/edit.svg"
import trashIcon from "assets/icons/trash.svg"

import { deleteHotelNestedSubCategoryAction, getCategoryItemsAction } from "redux/hotel/action"
import classes from "pages/private/marketing/menu/menu.module.scss"
import AddItems from "./AddItems"
import { hotelAction } from "redux/hotel/slice/user"

const CategoryContainerView = ({
  data,
  isEdit = false,
  setIsEditModalItem = () => {},
  setMenuItemsModal = () => {},
  handleAddCategory = () => {},
  setCurrentCategoryData = () => {},
  linkNestedCategory,
  isEditItem,
  setIsEditItem,
  searchedText
}) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [modal, setDeleteModal] = useState(false)
  const [open, setOpen] = useState(false)

  const { dynamicFieldsGroup } = useSelector((state) => state.hotel)

  const subcategoryId = data?.nested_nested_subcategory_id
  const subcategoryName = data?.nested_nested_subcategory_name

  const handleEditCategory = () => {
    setCurrentCategoryData(data)
    handleAddCategory(true)
  }

  const handleAddNewItem = () => {
    dispatch(hotelAction.setNestedSubcategoryData(data))
    setOpen(true)
  }

  const handleEditItem = (item) => {
    setOpen(true)
    dispatch(getCategoryItemsAction(item))
  }

  const handleDeleteCategory = useCallback(() => {
    setDeleteModal(false)
    dispatch(
      deleteHotelNestedSubCategoryAction({
        id: subcategoryId,
        sub_category: linkNestedCategory?.id
      })
    )
  }, [subcategoryId, linkNestedCategory?.id])

  const handleClose = () => {
    setOpen(false)
    setIsEditItem(false)
  }

  function checkDetailView(item) {
    if (item === "Summary View") {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <DeleteConfirmationDialog
        title={`Are you sure you want to delete “${subcategoryName}”?`}
        description=" "
        style={{ textAlign: "center", width: "80%" }}
        onClose={() => setDeleteModal(false)}
        onDelete={handleDeleteCategory}
        open={modal}
      />

      <Card style={{ height: "fit-content" }}>
        <Row>
          <Col lg={12}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: isEdit || checkDetailView(linkNestedCategory?.list) ? "12px 16px" : "0",
                borderRadius: 8,
                border:
                  isEdit || checkDetailView(linkNestedCategory?.list)
                    ? `2px solid ${theme.palette.secondary.main}`
                    : "none"
              }}>
              <Typography variant="h2" className="d-flex align-items-center">
                {subcategoryName}
                {isEdit && (
                  <img
                    src={editIcon}
                    alt="edit"
                    className={`${classes.edit} ms-2`}
                    onClick={handleEditCategory}
                  />
                )}
              </Typography>

              {isEdit && (
                <div className="d-flex align-items-center">
                  <AddMenuItemButton
                    text="Add New Item"
                    typographyClass={classes.addButton}
                    onAddItems={() => handleAddNewItem()}
                  />
                  <img
                    src={trashIcon}
                    alt="delete"
                    className={`${classes.trashIcon} ms-3`}
                    onClick={() => setDeleteModal(true)}
                  />
                </div>
              )}
            </div>
          </Col>

          <Col lg={12}>
            {data?.items?.length > 0 ? (
              data?.items?.map((item, idx) => (
                <ListView
                  key={idx}
                  categoryIdData={data?.category_id}
                  categoryList={item}
                  isEdit={isEdit}
                  searchedText={searchedText}
                  setIsEditModalItem={setIsEditModalItem}
                  setMenuItemsModal={setMenuItemsModal}
                  handleEditItem={handleEditItem}
                  setIsEditItem={setIsEditItem}
                  handleAddNewItem={handleAddNewItem}
                  checkDetailView={checkDetailView}
                />
              ))
            ) : (
              <Typography className="mt-4 text-center" style={{ opacity: 0.6 }}>
                No Items Found
              </Typography>
            )}
          </Col>
        </Row>
      </Card>
      <AddItems
        open={open}
        isEdit={isEditItem}
        onClose={handleClose}
        dynamicFieldsGroup={dynamicFieldsGroup}
        linkNestedCategory={linkNestedCategory}
      />
    </>
  )
}

export default CategoryContainerView
